<div class="atlas-form mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-start mct-items-center mct-gap-28">
  <div class="mct-basis-40">
    <label>{{ 'committees.search.name' | translate | ucfirst }}</label>
    <input
      [(ngModel)]="searchParams.NameKeyword"
      [placeholder]="'committees.search.keywords-within-the-committee-name' | translate | ucfirst"
    />
  </div>
  <div class="mct-basis-40">
    <label>{{ 'committees.search.type' | translate | ucfirst }}</label>
    <input
      [(ngModel)]="searchParams.TypeKeyword"
      [placeholder]="'committees.search.keywords-within-the-committee-type' | translate | ucfirst"
    />
  </div>
  <div>
    <p-checkbox binary="true" [(ngModel)]="searchParams.IncludeInactive" inputId="includeInactive"> </p-checkbox>
    <label for="includeInactive">
      {{ 'committees.search.include-inactive-committees' | translate | ucfirst }}
    </label>
  </div>
</div>
